import { ImageOff, Trash2 } from 'lucide-react';
import { Toggle } from '../../shared/ui';
import { formatCurrency } from '../../shared/models';

// Mirrors iOS MenuItemRow: 60x60 image left, name, 2-line description,
// price + availability badge. Web adds the swipe-action equivalents as
// trailing controls: availability toggle (leading swipe) and delete
// (trailing destructive swipe).
export default function MenuItemRow({ item, onOpen, onToggleAvailability, onDelete, busy = false }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-3 flex items-stretch gap-3">
      <button
        type="button"
        onClick={onOpen}
        className="flex items-center gap-3 flex-1 min-w-0 text-left active:opacity-70"
      >
        {item.imageURL ? (
          <img
            src={item.imageURL}
            alt={item.name}
            loading="lazy"
            className="w-[60px] h-[60px] rounded-lg object-cover bg-gray-100 shrink-0"
          />
        ) : (
          <div className="w-[60px] h-[60px] rounded-lg bg-gray-100 flex items-center justify-center text-gray-300 shrink-0">
            <ImageOff size={22} />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm text-gray-900 truncate">{item.name}</p>
          <p className="text-xs text-gray-500 line-clamp-2 mt-0.5 min-h-[1rem]">
            {item.description}
          </p>
          <div className="flex items-center justify-between gap-2 mt-1.5">
            <span className="text-sm font-bold text-gray-900">
              {formatCurrency(item.price)}
            </span>
            <span className="flex items-center gap-1.5">
              {item.trackStock === true && (
                <span
                  className={`px-2 py-0.5 rounded text-[11px] font-semibold ${
                    (item.stockCount ?? 0) <= 0
                      ? 'bg-red-100 text-red-500'
                      : 'bg-blue-50 text-blue-600'
                  }`}
                >
                  {(item.stockCount ?? 0) <= 0 ? 'Out of Stock' : `Stock: ${item.stockCount}`}
                </span>
              )}
              <span
                className={`px-2 py-0.5 rounded text-[11px] font-semibold ${
                  item.isAvailable
                    ? 'bg-green-100 text-green-600'
                    : 'bg-red-100 text-red-500'
                }`}
              >
                {item.isAvailable ? 'Available' : 'Unavailable'}
              </span>
            </span>
          </div>
        </div>
      </button>
      <div className="flex flex-col items-end justify-between shrink-0 py-0.5">
        <button
          type="button"
          onClick={onDelete}
          disabled={busy}
          aria-label={`Delete ${item.name}`}
          className="w-8 h-8 rounded-full bg-red-50 text-red-500 flex items-center justify-center active:bg-red-100 disabled:opacity-50"
        >
          <Trash2 size={15} />
        </button>
        <Toggle
          checked={item.isAvailable}
          onChange={onToggleAvailability}
          disabled={busy}
        />
      </div>
    </div>
  );
}
